
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selfserve/tracker/service-request",
      function () {
        return require("private-next-pages/selfserve/tracker/service-request/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selfserve/tracker/service-request"])
      });
    }
  